var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xE5\xBD\xA2\xE7\x8A\xB6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 4.00544C26 1.7933 24.2539 0 22.1 0H3.9C1.74603 0 0 1.7933 0 4.00544V17.3569C0 19.5691 1.74603 21.3624 3.9 21.3624H19.0667L23.4 24.7002C24.4713 25.5254 26 24.7404 26 23.3651V4.00544ZM19.5 8.01089C19.5 7.27351 18.918 6.67574 18.2 6.67574H7.8C7.08201 6.67574 6.5 7.27351 6.5 8.01089C6.5 8.74826 7.08201 9.34603 7.8 9.34603H18.2C18.918 9.34603 19.5 8.74826 19.5 8.01089ZM18.2 12.0163C18.918 12.0163 19.5 12.6141 19.5 13.3515C19.5 14.0889 18.918 14.6866 18.2 14.6866H14.3C13.582 14.6866 13 14.0889 13 13.3515C13 12.6141 13.582 12.0163 14.3 12.0163H18.2Z",
    fill: "#8D90A5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/messageIcon.f0c66049c571a97aafaad9d663c8c6a3.svg";
export { ForwardRef as ReactComponent };